<template>
  <div class=" is-fullwidth">
    <div class="container is-fullwidth is-pulled-right">
        <div class="columns">
         <div class="col is-pulled-left"><button class="button is-primary mr-4" v-if="loading===false">Displaying {{ filteredOrders.length }} orders</button></div>
          
          <div class="col">
        <input class="input" v-model="search" placeholder="search orders ..."/>
          </div>
          <div class="col">
            <div class="select">
        <select  v-model="selected_quality_user_id">
                  <option value="">Filter By Quality User</option>
                  <option v-bind:value="row.userID" v-for="row in quality_users" :key="row.userID">{{ row.firstname }} {{row.surname }}</option>
                  
          </select>
          </div>
          </div>
          </div>
          <br />
    </div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
        <th>Qty</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>CAD ID</th>
          <th>Artworker</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Paper</th>
          <th>Rolls</th>
          <th>Gerber</th>
          <th>Quality User</th>
          <th >Process</th>
          
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="11" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="11" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
          <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
             <td ><router-link :to="'/digitalprint/view-order?ponumber=' + order.ponumber">{{order.ponumber}}</router-link></td>
             <td>{{  order.total_qty }}</td>
              
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.cad_id}}</td>
          <td>
            <div v-if="order.artworker_user_id > 0" >{{ order.artworker_firstname }} {{order.artworker_surname}}</div>
          </td>
          <td>{{order.deliverydate}}</td>
          <td>
               <button class="button is-small is-success"   v-if="order.print_location_id==1">Strabane</button>
                  <button class="button is-small is-link"   v-if="order.print_location_id==2">Giurgiu</button>
               
           </td>
           <td>
               <button class="button is-small is-success"   v-if="order.fabric_print_location_id==1">Strabane</button>
                  <button class="button is-small is-link"   v-if="order.fabric_print_location_id==2">Giurgiu</button>
           </td>
           <td>
               <button class="button is-small is-success"   v-if="order.gerber_print_location_id==1">Strabane</button>
                  <button class="button is-small is-link"   v-if="order.gerber_print_location_id==2">Giurgiu</button>
           </td>
          <td>
            <span v-if="artworkManager == true">
                <select class="select" v-model="order.artworker_quality_user_id" @change="assignQualityUser(order)">
                        <option value="0">Please select</option>
                        <option v-bind:value="row.userID" v-for="row in quality_users" :key="row.userID">{{ row.firstname }} {{row.surname }}</option>
                       
                </select>

              </span>
              <div v-if="artworkManager == false && artworkQualityUser == true" >
                
                <button class="button is-small is-primary" @click="assignQualityUserSelf(order)" :disabled="working===true" v-if="order.artworker_quality_user_id == 0 || order.artworker_quality_user_id == null || order.artworker_quality_user_id == '' " >Choose</button>
                 <div v-else>
                  {{ getUserFullName(order.artworker_quality_user_id) }}
                 </div>
              </div>
              <div v-if="artworkManager == false && artworkQualityUser == false">
                
                <div v-if="order.artworker_quality_user_id > 0" >{{ getUserFullName(order.artworker_quality_user_id) }}</div>
              </div>
              
          </td>
          <td >
                  <button class="button is-small is-info" @click="processOrder(order)" :disabled="working===true" v-if="order.total_qty >= 100 && order.artworker_quality_user_id > 0 && order.print_location_id > 0">Process</button>
                  <button class="button is-small is-success" @click="processOrder(order)" :disabled="working===true" v-if="order.total_qty < 100 && order.artworker_quality_user_id > 0 && order.print_location_id > 0">Completed</button>
              </td>
			</tr>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" v-if="1===2">Export</button>
    
    <OrderModal :showModal="showModal" @closeModal="showModal=false" :orderID="selectedOrderID"/>

    
  </div>
</template>

<script>
import XLSX from 'xlsx';

import OrderModal from '@/components/OrderModal';
import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import UserService from '@/services/UserService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	OrderModal
  },
   mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      locations: [],
      ASP_URL : process.env.VUE_APP_ASP_URL,
      quality_users: [],
      selected_quality_user_id: '',
      search: '',
      order_by: 'deliverydate ASC',
      user: []
    }
  },
   methods: {
      getUserFullName(userID) {
        const user = this.quality_users.find(user => user.userID === userID);
        return user ? `${user.firstname} ${user.surname}` : "Not Set";
      },
      async getQualityUsers() {
        UtilityService.getSimpleApiData(this.accessToken, "users?artworker_quality=1").then(
               response => this.quality_users = response 
            );
      },
      async getOrders() {
        this.loading=true
        OrderService.getQualityArtworkOrders(this.accessToken, "", this.selected_quality_user_id, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      async getUser(id) {
        //this.loading=true
        UserService.getUser(this.accessToken, id)
        .then(
          (user => {
            this.$set(this, "user", user);
            //this.loading=false
          }).bind(this)
        );
      },
    
      exportXLS() {
      //alert("hi")
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet JS"});
      XLSX.writeFile(wb, 'book.xlsx')

    },

    async processOrder(order) {
        this.working = true

        var formdata = {}

        if(order.total_qty >= 100)
        { 
          formdata = { 
              _method: 'patch',
              artwork_quality_check: 1,
              //artworker_quality_user_id : order.artworker_quality_user_id
          }; 
        }else {
            formdata = { 
              _method: 'patch',
              artwork_quality_check: 1,
              artwork_completed: 1,
              //artworker_quality_user_id : order.artworker_quality_user_id
          }; 
        }
       

        OrderService.updateOrder(this.accessToken, order.orderID, formdata)
        .then(() => {
            order.artwork_quality_check = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async assignQualityUserSelf(order) {
        this.working = true

        if(confirm("Are you sure you want to assign this job to yourself ?"))
        {

          var formdata = { 
              _method: 'patch',
              artworker_quality_user_id: "self"
          }; 

          OrderService.updateOrder(this.accessToken, order.orderID, formdata)
          .then((response) => {
              order.artworker_quality_user_id = response.artworker_quality_user_id
              order.artworker_quality_firstname = response.artworker_quality_firstname
              order.artworker_quality_surname = response.artworker_quality_surname
              order.artworker_quality_email = response.artworker_quality_email
              this.working = false
              //console.log(response)
            }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        }
        else{
          this.working = false
        }
    },
    async assignQualityUser(order) {
        this.working = true
        var questionText = "Are you sure you want to assign this job ?";

        if(order.artworker_quality_user_id == 0 || order.artworker_quality_user_id == "")
        {
          questionText = "Are you sure you want to un-assign this job?";
        }

        if(confirm(questionText))
        {

          var formdata = { 
              _method: 'patch',
              artworker_quality_user_id: order.artworker_quality_user_id
          }; 

          OrderService.updateOrder(this.accessToken, order.orderID, formdata)
          .then((response) => {
              //order.artworker_user_id = response.artworker_user_id
              //order.artworker_firstname = response.artworker_firstname
             // order.artworker_surname = response.artworker_surname
              this.working = false
              console.log(response)
            }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        }
        else{
          order.artworker_quality_user_id = 0
          this.working = false
        }
    }
    
  },
  computed : {
     filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.artwork_quality_check == 0) // u.artwork_new == 0 && u.artwork_repeat == 0 &&
            {
              return 1
            }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     artworkManager: function() {
       return this.$auth.user.roles.includes("Artwork Manager")
       
     },
     artworkQualityUser: function() {
       return this.$auth.user.roles.includes("Artwork Quality") || this.user.artworker_quality == true
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
            this.getLocations();
            this.getQualityUsers();
            this.getUser("self");

        });
  },
 
  mounted() {
    
      
  },
  watch: {
    selected_quality_user_id: function () {
      this.orders = []
      this.getOrders();
      
    },
  }
}


</script>

